import React from "react";

const Background = ({ children }) => {
  return <div className="banner banner-container">{children}</div>;
};

export default Background;
